naiveShouldComponentUpdate = require 'lib/util/naive-should-component-update'
React = require 'react'
t = require('views/internal/recup-with-helpers')('select_member')
localizeCount = require 'lib/localize-count'
trackUe = require 'debug/trackUe'
OrgFeatures = require 'data/org-features'

module.exports = class AutoCompleteMultiBoardGuestAlert extends React.Component
  displayName: 'AutoCompleteMultiBoardGuestAlert'

  constructor: (props) ->
    super(props)

  shouldComponentUpdate: naiveShouldComponentUpdate

  render: t.renderable ->
    {
      displayOrg,
      isDesktop
    } = @props

    owned = displayOrg?.owned()
    teamUrl = displayOrg?.get('url')

    t.div {
      onMouseDown: @onMouseDown.bind(@)
    }, =>
      if owned && displayOrg && !isDesktop
        if displayOrg.getAvailableLicenseCount() > 0
          t.format 'multi-board-guest-alert-as-admin'
        else
          t.format 'multi-board-guest-alert-as-admin-no-seats'
      else if isDesktop
        t.format 'multi-board-guest-alert-desktop'
      else
        if displayOrg?
          admins = displayOrg.adminList.map((member) -> member.get('fullName') || member.get('username'))
          if admins.length == 1
            t.format 'multi-board-guest-alert-as-member-with-1-admin', { admin1: admins[0] }
          else if admins.length == 2
            t.format 'multi-board-guest-alert-as-member-with-2-admins', { admin1: admins[0], admin2: admins[1] }
          else if admins.length == 3
            t.format 'multi-board-guest-alert-as-member-with-3-admins', { admin1: admins[0], admin2: admins[1], admin3: admins[2] }
          else
            others = localizeCount 'others', admins.length - 3
            t.format 'multi-board-guest-alert-as-member-with-more-admins', { admin1: admins[0], admin2: admins[1], admin3: admins[2], others, othersUrl: "#{teamUrl}/members" }
        else
          t.format 'multi-board-guest-alert-as-guest'

      if !isDesktop
        t.text ' '
        helpUrl = 'https://help.trello.com/article/1123-multi-board-guests'
        t.a
          href: helpUrl
          target: '_blank'
          onMouseDown: (e) ->
            window.open(helpUrl, '_blank')
            trackUe(
              'invite to board'
              'clicks'
              'mbg learn more link'
              ''
              ''
              'by clicking on learn more link'
              'organizationid': displayOrg.id
            )
            e.preventDefault()
            e.stopPropagation()
        , ->
          t.format 'learn-more'



  onMouseDown: (e) ->
    if e.target.classList.contains('stop-propagation')
      e.preventDefault()
      if e.target.href
        window.open(e.target.href, '_blank')



// WEBPACK FOOTER //
// ./app/scripts/views/organization/invite-member-autocomplete-multi-board-guest-alert.coffee